export default {
  common: {
    loading: "로딩 중...",
    cancel: "취소",
    confirm: "확인",
    noMore: "더 이상 데이터가 없습니다",
    loadMore: "위로 올려서 더 보기",
    loadingMore: "더 불러오는 중...",
    refreshSuccess: "새로고침 성공",
    refreshFailed: "새로고침 실패",
    landscapeTip: "더 나은 경험을 위해 휴대폰을 세로 모드로 회전해 주세요",
    submit: "제출",
    all: "전체",
    language: "언어",
  },
  tabBar: {
    home: "홈",
    notice: "메시지",
    profile: "나의",
  },
  notice: {
    title: "메시지 알림",
    tabs: {
      notification: "알림",
      reply: "내게 달린 답글",
      mention: "{'@'}나",
      like: "좋아요",
    },
    replyComment: "{username} 님이 당신의 댓글에 답글을 달았습니다",
    replyPost: "{username} 님이 당신의 게시물에 답글을 달았습니다",
    mentionComment: "{username} 님이 당신의 댓글을 멘션했습니다",
    mentionPost: "{username} 님이 당신의 게시물을 멘션했습니다",
    likeComment: "{username} 님이 당신의 댓글을 좋아합니다",
    likePost: "{username} 님이 당신의 게시물을 좋아합니다",
    system: "시스템 알림",
    empty: "메시지 없음",
  },
  home: {
    gameName: "Puzzles & Survival",
    unboundRole: "캐릭터 미연동",
    pleaseLogin: "먼저 로그인하세요",
    loginNow: "로그인",
    loginInSuccess: "로그인 성공",
    signIn: "출석 체크",
    hasSigned: "출석 완료",
    signInFailedTip: "출석 체크 실패, 잠시 후 다시 시도해 주세요",
    signSuccess: "출석 체크 성공",
    signFailed: "출석 체크 실패",
    goToShop: "포인트 센터로 이동",
    pullToRefresh: "아래로 당겨 새로고침",
    releaseToRefresh: "놓아서 새로고침",
    sortByTime: "최신",
    sortByLastPost: "최근 댓글",
    tags: {
      recommend: "추천",
      chats: "소통",
      guide: "공략",
      activity: "이벤트",
      news: "뉴스",
    },
  },
  post: {
    title: "post",
    create: {
      title: "포스트",
      submit: "게시",
      titlePlaceholder: "제목을 입력해 주세요",
      contentPlaceholder: "지금 하고 싶은 말을 적어 보세요...",
      image: "사진",
      video: "동영상",
      mention: "{'@'}",
      selectBoard: "게시판 선택",
      topicLabel: "주제",
      imageSizeLimit: "이미지 크기는 5MB를 초과할 수 없습니다",
      videoSizeLimit: "동영상 크기는 50MB를 초과할 수 없습니다",
      titleEmpty: "제목을 입력해 주세요",
      contentEmpty: "내용을 입력해 주세요",
      submitting: "게시 중...",
      success: "게시 성공",
      failed: "게시 실패",
      imageUploading: "이미지 업로드 중, 잠시만 기다려 주세요...",
      imageUploadSuccess: "이미지 업로드 성공",
      imageUploadFailed: "이미지 업로드 실패",
      videoUploading: "동영상 업로드 중, 잠시만 기다려 주세요...",
      videoUploadSuccess: "동영상 업로드 성공",
      videoUploadFailed: "동영상 업로드 실패",
      maxCharsReached: "최대 글자 수에 도달했습니다 ({max}자)",
      invalidFileType: "지원하지 않는 파일 형식입니다",
      fileTooLarge: "파일 크기가 제한을 초과했습니다 (최대 {maxSize})",
    },
  },
  postDetail: {
    writeSomething: "내용을 작성해 주세요...",
    sending: "발송 중...",
    sendSuccess: "발송 완료",
    sendFailed: "발송 실패",
    loadFailed: "로딩 실패",
    noContent: "내용이 없습니다",
    allReplies: "모든 답글",
    onlyAuthor: "작성자만 보기",
    earliest: "가장 오래된 답글",
    latest: "최신 답글",
    allComments: "전체 {num}개의 답글",
    replyTo: "답글",
    author: "작성자",
    floor: "층",
    reply: "답글",
    favoriteSuccess: "저장 완료",
    cancelFavorite: "저장 취소 완료",
    viewOriginalPost: "원본 게시물 보기",
    commentTooShort: "댓글은 최소 5자 이상 입력해 주세요",
    translate: "번역",
    translating: "번역 중...",
    translateSuccess: "번역 성공",
    translateFailed: "번역 실패",
    translatedTo: "번역됨",
  },
  operateModal: {
    title: "조작",
    copyLink: "링크 복사",
    delete: "삭제",
    shareToGame: "게임 내 공유",
    copySuccess: "복사 완료",
    confirmDelete: "이 게시물을 삭제하시겠습니까?",
    deleteSuccess: "삭제 완료",
    deleteFailed: "삭제 실패",
    copyFailed: "복사 실패",
  },
  shareModal: {
    selectChannelTitle: "공유할 채널을 선택해 주세요",
    channelLabel: "채널",
    channelPlaceholder: "채널 선택",
    alliance: "연맹",
    shareSuccess: "공유 완료",
    continueBrowse: "계속 보기",
    goToGame: "게임에서 보기",
    noThreadTip: "먼저 게시글을 열어주세요",
  },
  profile: {
    title: "프로필",
    editNickname: "닉네임 변경",
    communityId: "커뮤니티 ID",
    followers: "팔로워",
    follow: "팔로우",
    followSuccess: "팔로우 완료",
    unfollowSuccess: "팔로우 취소 완료",
    addLikeSuccess: "좋아요 성공",
    cancelLikeSuccess: "좋아요 취소 성공",
    likes: "받은 좋아요",
    tabs: {
      posts: "내 소식",
      favorites: "나의 저장",
    },
    followed: "팔로우 중",
    noPosts: "소식 없음",
    noFavorites: "저장 없음",
    shopLabel: "포인트 상점",
  },
  search: {
    btn: "검색",
    hotTitle: "인기 검색어",
    historyTitle: "검색 기록",
    tabs: {
      post: "게시물",
      user: "유저",
    },
    empty: "관련 검색 결과 없음",
    filter: {
      title: "정렬",
      views: "인기",
      dateline: "최신",
    },
    relatedPosts: "관련 게시물",
  },
  nicknameModify: {
    placeholder: "닉네임을 입력해 주세요",
    myCoins: "내 포인트: ",
    getMore: "획득",
    description:
      "닉네임 변경에는 50 포인트가 필요합니다. 매월 첫 변경은 무료입니다.",
    alreadyRenamed:
      "이번 달에 닉네임을 이미 변경하셨습니다(한 달에 1번 변경 가능)",
    sameNickname: "새 닉네임은 현재 닉네임과 같을 수 없습니다",
    coinNotEnough: "포인트 부족",
    nicknameTooShort: "닉네임은 3글자 이상이어야 합니다",
    viewRecord: "수정 기록 보기",
    recordTitle: "수정 기록",
    date: "날짜",
    changedNickname: "닉네임 변경",
    cost: "소모",
    success: "수정 성공",
  },
  shop: {
    title: "교환 센터",
    record: "교환 기록",
    emptyTip: "상점 준비 중... 많이 기대해 주세요!",
    bindRole: "캐릭터 연동",
    switchRole: "캐릭터 변경",
    tabs: {
      tasks: "포인트 작업",
      rewards: "보상 교환",
    },
    taskInProgress: "진행 중",
    taskCompleted: "완료됨",
    goToComplete: "완료하기",
    exchange: "교환",
    exchanged: "교환됨",
    exchangeConfirmTitle: "보상을 교환하시겠습니까?",
    currentCoins: "현재 포인트",
    costCoins: "소모 포인트",
    receiveRole: "수령 캐릭터",
    exchangeSuccess: "교환 성공",
    exchangeFailed: "교환 실패",
  },
  exchangeRecord: {
    time: "시간",
    content: "내용",
    points: "포인트",
    empty: "교환 기록 없음",
  },
  setting: {
    title: "설정",
    about: "회사 소개",
    service: "이용 약관",
    privacy: "개인정보 처리방침",
    logout: "로그아웃",
    logoutSuccess: "로그아웃되었습니다",
  },
  avatar: {
    title: "프로필 사진 변경",
  },
  commentModal: {
    title: "댓글",
    placeholder: "댓글 쓰기...",
    replyTo: "{username}님에게 답글",
  },
  bindRole: {
    title: "캐릭터 연동",
    modifyTitle: "연동 캐릭터 변경",
    server: "서버:",
    role: "캐릭터명:",
    serverPlaceholder: "서버를 선택하세요",
    rolePlaceholder: "캐릭터를 선택하세요",
    bindSuccess: "캐릭터 연동 성공",
    bindFailed: "캐릭터 연동 실패",
    getServerListFailed: "서버 목록 불러오기 실패",
    getRoleListFailed: "캐릭터 목록 불러오기 실패",
    noRole: "캐릭터 없음",
    recentServers: "소속 서버",
    allServers: "전체 서버",
  },
  mentionModal: {
    title: "유저 선택",
    searchPlaceholder: "유저 검색",
  },
  linkModal: {
    title: "링크 삽입",
    viewTitle: "링크 보기",
    textLabel: "링크 텍스트",
    textPlaceholder: "링크 텍스트를 입력하세요",
    urlLabel: "링크 주소",
    urlPlaceholder: "링크 주소를 입력하세요",
    close: "닫기",
  },
  time: {
    minutesAgo: "{minutes}분 전",
    hoursAgo: "{hours}시간 전",
  },
  maintenance: {
    title: "페이지 유지보수 중",
    message:
      "죄송합니다. 현재 게임 포럼이 유지보수 중입니다. 나중에 다시 시도해주세요.",
  },
  error: {
    common: "조작 실패, 나중에 다시 시도해 주세요",
    50002: "토큰이 유효하지 않거나 만료되었습니다",
    50301: "게시할 권한이 없습니다",
    50302: "게시 횟수가 한도에 도달했습니다",
    50303: "내용이 너무 깁니다. 수정 후 다시 시도해 주세요.",
    50304:
      "내용에 민감한 단어가 포함되어 있습니다. 수정 후 다시 시도해 주세요.",
    50308: "이 게시물을 볼 수 있는 권한이 없습니다",
    50309: "게시물이 삭제되었거나 이동되었습니다",
    50351: "스레드가 닫혀 답글을 달 수 없습니다",
    50353: "답글을 달 권한이 없습니다",
    50354: "이 게시판에서는 답글이 금지되어 있습니다",
    50355: "게시물 게시 빈도가 너무 잦습니다. 잠시 후 다시 시도해 주세요.",
    50356: "시간당 게시물 작성 수가 한도에 도달했습니다",
    50361: "댓글이 존재하지 않습니다",
    50500: "검색 권한이 없습니다",
    50501: "검색 기능이 비활성화되었습니다",
    50502:
      "내용에 민감한 단어가 포함되어 있습니다. 수정 후 다시 시도해 주세요.",
    50006: "이 닉네임은 이미 다른 유저가 사용 중입니다",
    50007: "이번 달에 닉네임을 이미 변경하셨습니다(한 달에 1번 변경 가능)",
    50008: "포인트 부족",
    50505: "검색 빈도가 너무 잦습니다. 나중에 다시 시도해 주세요.",
    50703: "이미지 심사 미통과",
    50704: "이미지 내용이 규정에 부합하지 않습니다",
    50214: "공유에 실패했습니다. @:shareModal.alliance에 가입하지 않았습니다.",
  },
};
